document.addEventListener("DOMContentLoaded", e => {
    let items = []
      , totalQuantity = 0;
    const addtoboxbtns = document.querySelectorAll(".add_to_box")
      , cart = document.querySelector(".bundle_cart_drawer")
      , cartOverlay = document.querySelector(".bundle_cart_drawer_overlay")
      , closeDrawer = document.querySelector(".close_drawer")
      , viewbox = document.querySelector(".view-box")
      , cartItemsContainer = document.querySelector(".bundle_cart_drawer_items")
      , bundle_progess_bar = document.querySelector(".bundle_progess_bar")
      , progressCount = document.querySelector("#progress-bar-item-count")
      , addToCartBtn = document.querySelector(".bundle_cart_drawer_footer button")
      , drawerInfo = document.querySelector(".bundle_cart_drawer_info span")
      , bundleLimit = parseInt(document.querySelector(".bundle_main").getAttribute("data-bundle-limit"));
    window.selectMedia = function(input) {
        let selectWrapper = input.closest(".bundle_product")
          , button = selectWrapper.querySelector('button[onclick="addToBox(this)"]')
          , defaultMedia = selectWrapper.getAttribute("data-product-img")
          , image = selectWrapper.querySelector(".bundle_product_image img")
          , checkedSelects = selectWrapper.querySelectorAll('select[onchange="selectMedia(this)"]')
          , selectedText = Array.from(checkedSelects).map(el => {
            let option = el.options[el.selectedIndex];
            return option ? option.textContent.trim() : ""
        }
        ).join(" / ");
        console.log(selectedText);
        let mediaSelect = selectWrapper.querySelector('select[name="media-select"]')
          , media = null;
        mediaSelect && Array.from(mediaSelect.options).forEach(option => {
            option.textContent.trim() === selectedText && (media = option.getAttribute("data-media"))
        }
        ),
        console.log(media),
        !media || media.includes("Liquid error") ? (button.setAttribute("data-product-img", defaultMedia),
        image.setAttribute("src", defaultMedia),
        image.setAttribute("srcset", defaultMedia)) : (button.setAttribute("data-product-img", media),
        image.setAttribute("src", media),
        image.setAttribute("srcset", media))
    }
    ,
    window.setMedia = function(input) {
        let inputWrapper = input.closest(".bundle_product_popup_inner_content")
          , button = inputWrapper.querySelector("button.popup_addbtn")
          , defaultMedia = inputWrapper.getAttribute("data-product-img")
          , checkedInputs = inputWrapper.querySelectorAll("input:checked")
          , selectedText = Array.from(checkedInputs).map(el => {
            let label = el.closest("label");
            return label ? label.textContent.trim() : el.value.trim()
        }
        ).join(" / ")
          , select = inputWrapper.querySelector('select[name="media-select"]')
          , mediaId = null
          , media = null;
        select && Array.from(select.options).forEach(option => {
            option.textContent.trim() === selectedText && (mediaId = option.getAttribute("data-media-id"),
            media = option.getAttribute("data-media"))
        }
        ),
        console.log(media),
        media.includes("Liquid error") ? button.setAttribute("data-product-img", defaultMedia) : button.setAttribute("data-product-img", media);
        let popupInner = input.closest(".bundle_product_popup_inner");
        return popupInner && mediaId && popupInner.querySelectorAll(".popup_image").forEach( (slide, index) => {
            slide.getAttribute("data-media-id") === mediaId && $(popupInner).find(".popup_images").slick("slickGoTo", index)
        }
        ),
        {
            selectedText,
            mediaId
        }
    }
    ,
    window.addToBox = function(button) {
        const isPopup = button.classList.contains("popup_addbtn")
          , productId = button.getAttribute("data-product-id")
          , productImage = button.getAttribute("data-product-img")
          , productTitle = button.getAttribute("data-product-title");
        let options = [];
        if (isPopup) {
            const wrapper = button.closest(".bundle_product_popup_content");
            if (!wrapper)
                return;
            const inputs = wrapper.querySelectorAll("input:checked");
            options = Array.from(inputs).map(input => ({
                name: input.getAttribute("data-option"),
                value: input.value
            }))
        } else {
            const wrapper = button.closest(".bundle_product");
            if (!wrapper)
                return;
            const selects = wrapper.querySelectorAll("select[data-select]");
            options = Array.from(selects).map(select => ({
                name: select.getAttribute("data-option"),
                value: select.value
            }))
        }
        const existingItem = items.find(item => item.productId !== productId || item.options.length !== options.length ? !1 : item.options.every( (opt, index) => opt.name === options[index].name && opt.value === options[index].value));
        if (totalQuantity + 1 > bundleLimit) {
            document.querySelectorAll(".add_to_box, .popup_addbtn").forEach(btn => btn.setAttribute("disabled", "disabled"));
            return
        }
        existingItem ? existingItem.quantity += 1 : items.push({
            productId,
            quantity: 1,
            productTitle,
            productImage,
            options
        }),
        totalQuantity = items.reduce( (total, item) => total + item.quantity, 0),
        renderCartItems(),
        updateProgressBar(),
        isPopup && closePopup(button),
        console.log("items:", items)
    }
    ,
    window.openProductPopup = function(button) {
        const wrapper = button.closest(".bundle_product");
        if (!wrapper)
            return;
        const hasPopup = wrapper.querySelector(".bundle_product_popup_main");
        if (!hasPopup)
            return;
        hasPopup.classList.add("open");
        const slickTarget = hasPopup.querySelector(".popup_images");
        slickTarget && ($(slickTarget).hasClass("slick-initialized") && $(slickTarget).slick("unslick"),
        $(slickTarget).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: !0,
            dots: !0,
            fade: !0,
            infinite: !0
        }))
    }
    ,
    window.closePopup = function(button) {
        const popup = button.closest(".bundle_product_popup_main");
        popup && popup.classList.remove("open")
    }
    ;
    function renderCartItems() {
        cartItemsContainer.innerHTML = "",
        items.forEach(item => {
            const itemWrapper = document.createElement("div");
            itemWrapper.classList.add("bundle_cart_drawer_item"),
            itemWrapper.innerHTML = `
      <div class="bundle_cart_drawer_item_content">
        <img src="${item.productImage}" alt="${item.productTitle}">
        <p>${item.productTitle}</p>
      </div>
      <div class="bundle_cart_drawer_item_actions">
        <span>x${item.quantity}</span>
        <button class="remove_btn" data-product-id="${item.productId}">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z"/>
            <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z"/>
          </svg>
        </button>
      </div>
    `,
            itemWrapper.querySelector(".remove_btn").addEventListener("click", () => {
                removeItem(item.productId)
            }
            ),
            cartItemsContainer.appendChild(itemWrapper)
        }
        )
    }
    function removeItem(productId) {
        const itemIndex = items.findIndex(item => item.productId === productId);
        itemIndex !== -1 && (items[itemIndex].quantity > 1 ? items[itemIndex].quantity -= 1 : items.splice(itemIndex, 1)),
        totalQuantity = items.reduce( (total, item) => total + item.quantity, 0),
        addtoboxbtns.forEach(btn => btn.removeAttribute("disabled")),
        renderCartItems(),
        updateProgressBar()
    }
    function updateProgressBar() {
        totalQuantity > 0 ? (bundle_progess_bar.style.display = "flex",
        progressCount.textContent = totalQuantity,
        addToCartBtn.style.display = "flex",
        totalQuantity === bundleLimit ? (bundle_progess_bar.classList.add("qualified"),
        cart.classList.add("active"),
        cartOverlay.classList.add("active")) : (bundle_progess_bar.classList.remove("qualified"),
        addToCartBtn.style.display = "none")) : bundle_progess_bar.style.display = "none",
        drawerInfo.innerHTML = `(${totalQuantity}/${bundleLimit})`
    }
    cartOverlay.addEventListener("click", hideCart),
    closeDrawer.addEventListener("click", hideCart),
    viewbox.addEventListener("click", openCart);
    function hideCart() {
        cart.classList.remove("active"),
        cartOverlay.classList.remove("active")
    }
    function openCart() {
        cart.classList.add("active"),
        cartOverlay.classList.add("active")
    }
    addToCartBtn.addEventListener("click", createBundle);
    async function createBundle() {
        addToCartBtn.classList.add("loading_state");
        const mainProductVariantId = document.querySelector(".bundle_main").getAttribute("data-product-variant-id")
          , productsArray = items.map(item => ({
            productId: item.productId,
            quantity: item.quantity,
            productTitle: item.productTitle,
            productImage: item.productImage,
            options: item.options
        }));
        console.log("Products:", productsArray);
        const properties = {};
        properties.Product = "Bundle",
        items.forEach( (item, index) => {
            const optionText = item.options.map(opt => `${opt.name}: ${opt.value}`).join(", ");
            properties[`Title-${index + 1}`] = `${item.productTitle} (${optionText}) x ${item.quantity}`,
            properties[`_Image-${index + 1}`] = `https:${item.productImage}`
        }
        );
        const formData = {
            items: [{
                id: mainProductVariantId,
                quantity: 1,
                properties
            }]
        };
        fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(formData)
        }).then(response => response.json()).then(data => {
            addToCartBtn.classList.remove("loading_state"),
            console.log("Added to cart:", data),
            document.dispatchEvent(new CustomEvent("theme:cart:refresh")),
            hideCart(),
            document.dispatchEvent(new CustomEvent("theme:cart:toggle"))
        }
        ).catch(error => console.error("Error:", error))
    }
}
);
//# sourceMappingURL=/cdn/shop/t/3/assets/bundle-builder.js.map?v=65480240638324341271764623713
